import React, { ReactNode } from 'react';

export const countLabelFormatter =
  (
    at0: ReactNode,
    at1: ReactNode,
    atLower: (count: number) => ReactNode,
    atHigher: (count: number) => ReactNode,
  ) =>
  (count: number) => {
    if (count < 1) {
      return at0;
    } else if (count % 100 > 10 && count % 100 < 15) {
      return atHigher(count);
    } else if (count === 1) {
      return at1;
    } else if (count % 10 > 1 && count % 10 < 5) {
      return atLower(count);
    } else {
      return atHigher(count);
    }
  };

export const eventListingCountLabelFormatter = countLabelFormatter(
  '0 szkoleń',
  '1 szkolenie',
  (count) => `${count} szkolenia`,
  (count) => `${count} szkoleń`,
);

export const userCertificatesCountLabelFormatter = countLabelFormatter(
  '0 certyfikatów',
  '1 certyfikat',
  (count) => `${count} certyfikaty`,
  (count) => `${count} certyfikatów`,
);

export const materialQuantityFormatter = countLabelFormatter(
  <>0&nbsp;materiałów</>,
  <>1&nbsp;materiał</>,
  (count) => <>{count}&nbsp;materiały</>,
  (count) => <>{count}&nbsp;materiałów</>,
);
